<template>
  <div class="p-2 sm:p-4 md:p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6 gap-3 sm:gap-4">
      <div class="flex items-center space-x-2 sm:space-x-3">
        <div class="h-8 sm:h-10 w-1 bg-gradient-to-b from-indigo-500 to-purple-600 rounded-full"></div>
        <div>
          <h1 class="text-lg sm:text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">Reporte de Reparación de Equipos</h1>
          <p class="text-[10px] sm:text-sm text-gray-500 dark:text-gray-400 flex items-center mt-0.5">
            <Icon icon="mdi:tools" class="mr-1 text-sm sm:text-base" />
            <span class="hidden xs:inline">SYSTEM JJ - Taller y Servicio Técnico</span>
            <span class="xs:hidden">SYSTEM JJ</span>
          </p>
        </div>
      </div>
      <button
        @click="volver"
        class="px-3 sm:px-4 py-1.5 sm:py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm"
      >
        <Icon icon="mdi:arrow-left" class="text-base sm:text-lg" />
        Volver
      </button>
    </div>

    <!-- Filtros -->
    <div class="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-3 sm:p-4 md:p-6 mb-4 sm:mb-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        <div>
          <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Estado</label>
          <select
            v-model="filtros.idEstado"
            class="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          >
            <option value="todos">Todos los estados</option>
            <option v-for="est in estados" :key="est.idEstadoRecepcion" :value="est.idEstadoRecepcion">
              {{ est.nombre?.toUpperCase() }}
            </option>
          </select>
        </div>

        <div>
          <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Técnico</label>
          <select
            v-model="filtros.idTecnico"
            class="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          >
            <option value="todos">Todos los técnicos</option>
            <option v-for="tec in tecnicos" :key="tec.idTecnico" :value="tec.idTecnico">
              {{ tec.nombre }} {{ tec.apellido }}
            </option>
          </select>
        </div>

        <div>
          <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Desde</label>
          <input
            v-model="filtros.fechaDesde"
            type="date"
            class="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          />
        </div>

        <div>
          <label class="block text-[10px] sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">Hasta</label>
          <input
            v-model="filtros.fechaHasta"
            type="date"
            class="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          />
        </div>

        <div class="flex gap-2 items-end">
          <button
            @click="aplicarFiltros"
            class="flex-1 px-4 py-2 sm:py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2 text-sm"
          >
            <Icon icon="mdi:filter" class="text-base" />
            <span class="hidden xs:inline">Filtrar</span>
          </button>
          <button
            @click="limpiarFiltros"
            class="flex-1 px-4 py-2 sm:py-3 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200 font-medium flex items-center justify-center gap-2 text-sm"
          >
            <Icon icon="mdi:refresh" class="text-base" />
            <span class="hidden xs:inline">Limpiar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Tarjetas de Estadísticas -->
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3 md:gap-4 mb-4 sm:mb-6">
      <!-- Total Equipos -->
      <div class="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-gray-500 dark:text-gray-400 font-medium">Total Equipos</p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-gray-800 dark:text-white">{{ estadisticas.total }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg sm:rounded-xl">
            <Icon icon="mdi:laptop-off" class="text-base sm:text-lg md:text-xl text-blue-600 dark:text-blue-400" />
          </div>
        </div>
      </div>

      <!-- Reparados -->
      <div class="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-gray-500 dark:text-gray-400 font-medium">Reparados</p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-green-600 dark:text-green-400">{{ estadisticas.reparados }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-green-100 dark:bg-green-900/30 rounded-lg sm:rounded-xl">
            <Icon icon="mdi:check-circle" class="text-base sm:text-lg md:text-xl text-green-600 dark:text-green-400" />
          </div>
        </div>
      </div>

      <!-- Entregados -->
      <div class="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-gray-500 dark:text-gray-400 font-medium">Entregados</p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-indigo-600 dark:text-indigo-400">{{ estadisticas.entregados }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg sm:rounded-xl">
            <Icon icon="mdi:hand-okay" class="text-base sm:text-lg md:text-xl text-indigo-600 dark:text-indigo-400" />
          </div>
        </div>
      </div>

      <!-- Pendientes -->
      <div class="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-gray-500 dark:text-gray-400 font-medium">Pendientes</p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-orange-600 dark:text-orange-400">{{ estadisticas.pendientes }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg sm:rounded-xl">
            <Icon icon="mdi:clock-alert" class="text-base sm:text-lg md:text-xl text-orange-600 dark:text-orange-400" />
          </div>
        </div>
      </div>

      <!-- Cobrado $ -->
      <div 
        @click="irAPagoServicio" 
        class="bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-800/20 rounded-xl sm:rounded-2xl shadow-lg border border-emerald-200 dark:border-emerald-800 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200 cursor-pointer group hover:scale-[1.02]"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-emerald-700 dark:text-emerald-400 font-medium flex items-center gap-1">
              💵 Cobrado $
              <Icon icon="mdi:arrow-right-circle" class="text-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity text-xs sm:text-sm" />
            </p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-emerald-700 dark:text-emerald-300">${{ estadisticas.totalCobrado.toFixed(2) }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-emerald-200/50 dark:bg-emerald-800/30 rounded-lg sm:rounded-xl group-hover:bg-emerald-300/50 transition-colors">
            <Icon icon="mdi:cash-check" class="text-base sm:text-lg md:text-xl text-emerald-700 dark:text-emerald-400" />
          </div>
        </div>
      </div>

      <!-- Cashea $ -->
      <div 
        @click="irAPagoServicio" 
        class="bg-gradient-to-br from-rose-50 to-rose-100 dark:from-rose-900/20 dark:to-rose-800/20 rounded-xl sm:rounded-2xl shadow-lg border border-rose-200 dark:border-rose-800 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200 cursor-pointer group hover:scale-[1.02]"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-rose-700 dark:text-rose-400 font-medium flex items-center gap-1">
              💳 Cashea $
              <Icon icon="mdi:arrow-right-circle" class="text-rose-500 opacity-0 group-hover:opacity-100 transition-opacity text-xs sm:text-sm" />
            </p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-rose-700 dark:text-rose-300">${{ estadisticas.totalCashea.toFixed(2) }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-rose-200/50 dark:bg-rose-800/30 rounded-lg sm:rounded-xl group-hover:bg-rose-300/50 transition-colors">
            <Icon icon="mdi:credit-card-clock" class="text-base sm:text-lg md:text-xl text-rose-700 dark:text-rose-400" />
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjetas Totales - Fila 2 -->
    <div class="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 md:gap-4 mb-4 sm:mb-6">
      <!-- Servicio $ -->
      <div 
        @click="irAPagoServicio" 
        class="bg-gradient-to-br from-amber-50 to-amber-100 dark:from-amber-900/20 dark:to-amber-800/20 rounded-xl sm:rounded-2xl shadow-lg border border-amber-200 dark:border-amber-800 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200 cursor-pointer group hover:scale-[1.02]"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-amber-700 dark:text-amber-400 font-medium flex items-center gap-1">
              Servicio $
              <Icon icon="mdi:arrow-right-circle" class="text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity text-xs sm:text-sm" />
            </p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-amber-700 dark:text-amber-300">${{ estadisticas.totalServicios.toFixed(2) }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-amber-200/50 dark:bg-amber-800/30 rounded-lg sm:rounded-xl group-hover:bg-amber-300/50 transition-colors">
            <Icon icon="mdi:tools" class="text-base sm:text-lg md:text-xl text-amber-700 dark:text-amber-400" />
          </div>
        </div>
      </div>

      <!-- Producto $ -->
      <div 
        @click="irAPagoServicio" 
        class="bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-800/20 rounded-xl sm:rounded-2xl shadow-lg border border-emerald-200 dark:border-emerald-800 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200 cursor-pointer group hover:scale-[1.02]"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-emerald-700 dark:text-emerald-400 font-medium flex items-center gap-1">
              Producto $
              <Icon icon="mdi:arrow-right-circle" class="text-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity text-xs sm:text-sm" />
            </p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-emerald-700 dark:text-emerald-300">${{ estadisticas.totalProductos.toFixed(2) }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-emerald-200/50 dark:bg-emerald-800/30 rounded-lg sm:rounded-xl group-hover:bg-emerald-300/50 transition-colors">
            <Icon icon="mdi:cart-arrow-up" class="text-base sm:text-lg md:text-xl text-emerald-700 dark:text-emerald-400" />
          </div>
        </div>
      </div>

      <!-- Repuesto $ -->
      <div 
        @click="irAPagoServicio" 
        class="bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900/20 dark:to-orange-800/20 rounded-xl sm:rounded-2xl shadow-lg border border-orange-200 dark:border-orange-800 p-2 sm:p-3 md:p-4 hover:shadow-xl transition-all duration-200 cursor-pointer group hover:scale-[1.02]"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[8px] sm:text-[10px] md:text-xs text-orange-700 dark:text-orange-400 font-medium flex items-center gap-1">
              Repuesto $
              <Icon icon="mdi:arrow-right-circle" class="text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity text-xs sm:text-sm" />
            </p>
            <p class="text-base sm:text-lg md:text-2xl font-bold text-orange-700 dark:text-orange-300">${{ estadisticas.totalRepuestos.toFixed(2) }}</p>
          </div>
          <div class="p-1.5 sm:p-2 bg-orange-200/50 dark:bg-orange-800/30 rounded-lg sm:rounded-xl group-hover:bg-orange-300/50 transition-colors">
            <Icon icon="mdi:chip" class="text-base sm:text-lg md:text-xl text-orange-700 dark:text-orange-400" />
          </div>
        </div>
      </div>
    </div>

    <!-- Total General (fila completa) -->
    <div class="mb-4 sm:mb-6">
      <div 
        @click="irAPagoServicio" 
        class="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl sm:rounded-2xl shadow-xl p-3 sm:p-4 md:p-5 hover:shadow-2xl transition-all duration-200 cursor-pointer group hover:scale-[1.01]"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-[10px] sm:text-xs md:text-sm text-indigo-200 font-medium uppercase tracking-wider flex items-center gap-2">
              Total General (Órdenes)
              <Icon icon="mdi:arrow-right-circle" class="text-indigo-300 opacity-0 group-hover:opacity-100 transition-opacity text-sm sm:text-lg" />
            </p>
            <p class="text-lg sm:text-2xl md:text-3xl font-black text-white">${{ estadisticas.totalGeneral.toFixed(2) }}</p>
          </div>
          <div class="flex items-center gap-3 sm:gap-6">
            <div class="text-right">
              <p class="text-[9px] sm:text-[10px] md:text-xs text-emerald-200 font-bold uppercase tracking-wider">💵 Cobrado</p>
              <p class="text-sm sm:text-lg md:text-xl font-black text-emerald-300">${{ estadisticas.totalCobrado.toFixed(2) }}</p>
            </div>
            <div class="text-right">
              <p class="text-[9px] sm:text-[10px] md:text-xs text-rose-200 font-bold uppercase tracking-wider">💳 Cashea</p>
              <p class="text-sm sm:text-lg md:text-xl font-black text-rose-300">${{ estadisticas.totalCashea.toFixed(2) }}</p>
            </div>
            <div class="p-2 sm:p-3 bg-white/20 rounded-lg sm:rounded-xl group-hover:bg-white/30 transition-colors">
              <Icon icon="mdi:cash-multiple" class="text-xl sm:text-2xl md:text-3xl text-white" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de Recepciones -->
    <div class="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden">
      <div class="bg-gradient-to-r from-indigo-50 to-purple-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 md:px-6 py-3 sm:py-4 border-b border-gray-100 dark:border-gray-700">
        <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <h2 class="text-sm sm:text-base md:text-lg font-semibold text-gray-800 dark:text-white flex items-center">
            <div class="p-1.5 sm:p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg mr-2 sm:mr-3">
              <Icon icon="mdi:format-list-bulleted" class="text-indigo-600 dark:text-indigo-400 text-base sm:text-xl" />
            </div>
            Equipos en Taller
            <span v-if="recepcionesFiltradas.length > 0" class="ml-2 text-[10px] sm:text-sm bg-gray-200 dark:bg-gray-700 px-2 py-0.5 rounded-full">
              {{ recepcionesFiltradas.length }}
            </span>
          </h2>
          
          <div class="flex gap-2 w-full sm:w-auto">
            <button
              @click="exportarExcel"
              :disabled="recepcionesFiltradas.length === 0"
              :class="[
                'flex-1 sm:flex-none px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-1.5 text-xs sm:text-sm font-medium',
                recepcionesFiltradas.length > 0
                  ? 'bg-green-600 text-white hover:bg-green-700 shadow-md hover:shadow-lg'
                  : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
              ]"
            >
              <Icon icon="mdi:file-excel" class="text-base sm:text-lg" />
              <span class="hidden xs:inline">Excel</span>
            </button>
            <button
              @click="imprimirReporte"
              :disabled="recepcionesFiltradas.length === 0"
              :class="[
                'flex-1 sm:flex-none px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl transition-all duration-200 flex items-center justify-center gap-1.5 text-xs sm:text-sm font-medium',
                recepcionesFiltradas.length > 0
                  ? 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg'
                  : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
              ]"
            >
              <Icon icon="mdi:printer" class="text-base sm:text-lg" />
              <span class="hidden xs:inline">Imprimir</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="cargando" class="p-8 sm:p-12 text-center">
        <div class="inline-block animate-spin rounded-full h-6 w-6 sm:h-8 sm:w-8 border-3 border-indigo-500 border-t-transparent"></div>
        <p class="text-gray-500 dark:text-gray-400 mt-2 sm:mt-3 text-sm">Cargando registros...</p>
      </div>

      <!-- Tabla de datos -->
      <div v-else-if="recepcionesFiltradas.length > 0" class="overflow-x-auto">
        <!-- ===== TABLA DE ESCRITORIO ===== -->
        <table class="w-full text-sm hidden sm:table">
          <thead class="bg-gray-50 dark:bg-gray-700/50 sticky top-0 z-10">
            <tr>
              <th class="px-3 py-3 text-left font-bold text-xs text-indigo-600 dark:text-indigo-400 uppercase tracking-wider min-w-[80px]">Orden</th>
              <th class="px-3 py-3 text-left font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[90px]">Fecha</th>
              <th class="px-3 py-3 text-left font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[120px]">Cliente</th>
              <th class="px-3 py-3 text-left font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[100px]">Equipo</th>
              <th class="px-3 py-3 text-right font-bold text-xs text-gray-800 dark:text-white uppercase tracking-wider min-w-[90px]">Total $</th>
              <th class="px-3 py-3 text-right font-bold text-xs text-emerald-600 dark:text-emerald-400 uppercase tracking-wider min-w-[90px]">💵 Cobrado</th>
              <th class="px-3 py-3 text-right font-bold text-xs text-rose-600 dark:text-rose-400 uppercase tracking-wider min-w-[90px]">💳 Cashea</th>
              <th class="px-3 py-3 text-left font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[80px]">Recibido</th>
              <th class="px-3 py-3 text-left font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[80px]">Reparado</th>
              <th class="px-3 py-3 text-left font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[80px]">Entregado</th>
              <th class="px-3 py-3 text-center font-bold text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wider min-w-[90px]">Estado</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
            <tr v-for="item in itemsPaginados" :key="item.idRecepcionEquipo" class="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-150">
              <td class="px-3 py-3 whitespace-nowrap font-black text-indigo-600 dark:text-indigo-400 text-sm">
                #{{ item.numeroOrden }}
              </td>
              <td class="px-3 py-3 whitespace-nowrap text-gray-600 dark:text-gray-400 text-xs">
                <div class="flex flex-col">
                  <span class="font-black text-indigo-600 dark:text-indigo-400">{{ formatearFechaCorta(item.fechaPago || item.fechaEntrega || item.fechaIngreso) }}</span>
                  <span class="text-[9px] text-gray-400 italic">Ing: {{ formatearFechaCorta(item.fechaIngreso) }}</span>
                </div>
              </td>
              <td class="px-3 py-3 text-gray-900 dark:text-gray-200 text-sm font-bold">
                {{ item.nombreCliente }}
              </td>
              <td class="px-3 py-3 text-gray-700 dark:text-gray-300 text-sm">
                {{ item.descripcion }}
              </td>
              <td class="px-3 py-3 text-right font-black text-gray-900 dark:text-white text-base">
                ${{ (item.precioTotalUsd || 0).toFixed(2) }}
              </td>
              <td class="px-3 py-3 text-right font-black text-emerald-600 dark:text-emerald-400 text-base">
                ${{ (item.montoCobradoUsd || 0).toFixed(2) }}
              </td>
              <td class="px-3 py-3 text-right font-black text-rose-600 dark:text-rose-400 text-base">
                ${{ (item.montoPendienteUsd || 0).toFixed(2) }}
              </td>
              <td class="px-3 py-3 text-gray-600 dark:text-gray-400 text-xs italic">
                {{ item.nombreTecnicoRecepcion || item.nombreUsuario || '---' }}
              </td>
              <td class="px-3 py-3 text-gray-600 dark:text-gray-400 text-xs italic">
                {{ item.nombreTecnicoReparador || '---' }}
              </td>
              <td class="px-3 py-3 text-gray-600 dark:text-gray-400 text-xs italic">
                {{ item.nombreTecnicoEntrega || '---' }}
              </td>
              <td class="px-3 py-3 whitespace-nowrap text-center">
                <span :class="getEstadoStyle(item.nombreEstado)" class="inline-block px-2.5 py-1 text-[9px] font-black uppercase rounded-lg border shadow-sm">
                  {{ item.nombreEstado }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- ===== VERSIÓN MÓVIL: Tarjetas ===== -->
        <div class="sm:hidden space-y-3 p-3">
          <div 
            v-for="item in itemsPaginados" 
            :key="item.idRecepcionEquipo" 
            class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-3 shadow-sm hover:shadow-md transition-all duration-200"
          >
            <!-- Cabecera -->
            <div class="flex justify-between items-start mb-2">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-black text-indigo-600 dark:text-indigo-400 text-sm">#{{ item.numeroOrden }}</span>
                <span :class="getEstadoStyle(item.nombreEstado)" class="inline-block px-2 py-0.5 text-[8px] font-black uppercase rounded-lg border">
                  {{ item.nombreEstado }}
                </span>
              </div>
              <div class="text-right">
                <span class="font-black text-gray-900 dark:text-white text-sm">${{ (item.precioTotalUsd || 0).toFixed(2) }}</span>
              </div>
            </div>

            <!-- Cliente + Equipo -->
            <div class="grid grid-cols-2 gap-1 mb-2">
              <div>
                <p class="text-[8px] text-gray-400 uppercase font-bold">Cliente</p>
                <p class="text-xs font-bold text-gray-800 dark:text-white truncate">{{ item.nombreCliente }}</p>
              </div>
              <div>
                <p class="text-[8px] text-gray-400 uppercase font-bold">Equipo</p>
                <p class="text-xs text-gray-600 dark:text-gray-300 truncate">{{ item.descripcion }}</p>
              </div>
            </div>

            <!-- Cobrado / Cashea -->
            <div class="grid grid-cols-2 gap-2 mb-2 pt-2 border-t border-gray-100 dark:border-gray-700">
              <div class="text-center bg-emerald-50 dark:bg-emerald-900/20 rounded-lg py-1">
                <p class="text-[7px] text-emerald-700 dark:text-emerald-400 uppercase font-black">💵 Cobrado</p>
                <p class="text-sm font-black text-emerald-700 dark:text-emerald-400">${{ (item.montoCobradoUsd || 0).toFixed(2) }}</p>
              </div>
              <div class="text-center bg-rose-50 dark:bg-rose-900/20 rounded-lg py-1">
                <p class="text-[7px] text-rose-700 dark:text-rose-400 uppercase font-black">💳 Cashea</p>
                <p class="text-sm font-black text-rose-700 dark:text-rose-400">${{ (item.montoPendienteUsd || 0).toFixed(2) }}</p>
              </div>
            </div>

            <!-- Fechas -->
            <div class="grid grid-cols-3 gap-1">
              <div>
                <p class="text-[7px] text-gray-400 uppercase font-bold">Fecha</p>
                <p class="text-[10px] font-bold text-indigo-600 dark:text-indigo-400">{{ formatearFechaCorta(item.fechaPago || item.fechaEntrega || item.fechaIngreso) }}</p>
              </div>
              <div>
                <p class="text-[7px] text-gray-400 uppercase font-bold">Ingreso</p>
                <p class="text-[10px] text-gray-500">{{ formatearFechaCorta(item.fechaIngreso) }}</p>
              </div>
              <div>
                <p class="text-[7px] text-gray-400 uppercase font-bold">Recibió</p>
                <p class="text-[8px] text-gray-500 truncate">{{ item.nombreTecnicoRecepcion || '---' }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== PAGINACIÓN ===== -->
        <div class="flex flex-col xs:flex-row justify-between items-center gap-3 px-3 sm:px-4 py-3 sm:py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/30">
          <div class="text-[10px] sm:text-sm text-gray-600 dark:text-gray-400 text-center xs:text-left">
            Mostrando <span class="font-bold">{{ inicioPagina + 1 }}</span> - 
            <span class="font-bold">{{ Math.min(finPagina, recepcionesFiltradas.length) }}</span> 
            de <span class="font-bold">{{ recepcionesFiltradas.length }}</span>
          </div>
          
          <div class="flex items-center gap-1 sm:gap-2">
            <button
              @click="paginaAnterior"
              :disabled="paginaActual === 1"
              :class="[
                'px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg transition-all duration-200 flex items-center gap-0.5 sm:gap-1 text-xs sm:text-sm font-medium',
                paginaActual === 1
                  ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
                  : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 shadow-sm hover:shadow'
              ]"
            >
              <Icon icon="mdi:chevron-left" class="text-sm sm:text-base" />
              <span class="hidden xs:inline">Anterior</span>
            </button>

            <div class="flex gap-0.5 sm:gap-1">
              <button
                v-for="pag in paginasMostradas"
                :key="pag"
                @click="irPagina(pag)"
                :class="[
                  'w-7 h-7 sm:w-9 sm:h-9 rounded-lg transition-all duration-200 text-xs sm:text-sm font-bold',
                  pag === paginaActual
                    ? 'bg-indigo-600 text-white shadow-md shadow-indigo-500/30'
                    : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 border border-gray-200 dark:border-gray-600'
                ]"
              >
                {{ pag }}
              </button>
            </div>

            <button
              @click="paginaSiguiente"
              :disabled="paginaActual === totalPaginas"
              :class="[
                'px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg transition-all duration-200 flex items-center gap-0.5 sm:gap-1 text-xs sm:text-sm font-medium',
                paginaActual === totalPaginas
                  ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
                  : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 shadow-sm hover:shadow'
              ]"
            >
              <span class="hidden xs:inline">Siguiente</span>
              <Icon icon="mdi:chevron-right" class="text-sm sm:text-base" />
            </button>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div v-else class="text-center py-8 sm:py-12">
        <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-700/30 rounded-full w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 sm:mb-4 flex items-center justify-center">
          <Icon icon="mdi:laptop-off" class="text-3xl sm:text-4xl text-gray-400" />
        </div>
        <p class="text-gray-600 dark:text-gray-400 font-medium text-sm sm:text-base">No hay registros para mostrar</p>
        <p class="text-xs sm:text-sm text-gray-500 dark:text-gray-500 mt-1">Prueba cambiando los filtros</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import api from '@/api/recepcionEquipo.js';
import { obtenerTecnicos } from '@/api/tecnicos.js';
import { obtenerEstadosRecepcion } from '@/api/estadoRecepcion.js';
import { 
  imprimirReporteRecepcion, 
  exportarRecepcionExcel,
  calcularEstadisticasRecepcion 
} from '@/utils/reporteRecepcionEquipoGenerator.js';
import { formatearFechaCorta } from '@/utils/reporteProductosGenerator.js';
import { obtenerPagosSalidaEquipo } from '@/api/pagoSalidaEquipo.js';

export default {
  name: 'ReporteRecepcionEquipo',
  components: {
    Icon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    const d = new Date();
    const hoy = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return {
      cargando: false,
      recepciones: [],
      recepcionesFiltradas: [],
      tecnicos: [],
      estados: [],
      pagosGlobales: [],
      paginaActual: 1,
      itemsPorPagina: 5,
      filtros: {
        idEstado: 'todos',
        idTecnico: 'todos',
        fechaDesde: hoy,
        fechaHasta: ''
      },
      estadisticas: {
        total: 0,
        reparados: 0,
        entregados: 0,
        pendientes: 0,
        totalServicios: 0,
        totalProductos: 0,
        totalRepuestos: 0,
        totalGeneral: 0,
        totalCobrado: 0,
        totalCashea: 0
      }
    };
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.recepcionesFiltradas.length / this.itemsPorPagina);
    },
    
    inicioPagina() {
      return (this.paginaActual - 1) * this.itemsPorPagina;
    },
    
    finPagina() {
      return Math.min(this.inicioPagina + this.itemsPorPagina, this.recepcionesFiltradas.length);
    },
    
    itemsPaginados() {
      return this.recepcionesFiltradas.slice(this.inicioPagina, this.finPagina);
    },
    
    paginasMostradas() {
      const total = this.totalPaginas;
      const actual = this.paginaActual;
      const max = 5;
      let inicio = Math.max(1, actual - 2);
      let fin = Math.min(total, inicio + max - 1);
      
      if (fin - inicio + 1 < max) {
        inicio = Math.max(1, fin - max + 1);
      }
      
      const paginas = [];
      for (let i = inicio; i <= fin; i++) {
        paginas.push(i);
      }
      return paginas;
    }
  },
  watch: {
    recepcionesFiltradas() {
      this.paginaActual = 1;
    }
  },
  async mounted() {
    await this.cargarCatalogos();
    await this.cargarDatos();
  },
  methods: {
    formatearFechaCorta,
    
    irAPagoServicio() {
      this.$router.push('/pago-servicio');
    },
    
    paginaAnterior() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
    },
    
    paginaSiguiente() {
      if (this.paginaActual < this.totalPaginas) {
        this.paginaActual++;
      }
    },
    
    irPagina(pagina) {
      if (pagina >= 1 && pagina <= this.totalPaginas) {
        this.paginaActual = pagina;
      }
    },
    
    getEstadoStyle(estado) {
      const e = estado?.toLowerCase() || '';
      if (e.includes('diagno')) return 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800';
      if (e.includes('reparado')) return 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800';
      if (e.includes('entrega')) return 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800';
      if (e.includes('espera')) return 'bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800';
      return 'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-900/30 dark:text-gray-300 dark:border-gray-800';
    },

    async cargarCatalogos() {
      try {
        const [tecs, ests] = await Promise.all([
          obtenerTecnicos(),
          obtenerEstadosRecepcion(true)
        ]);
        if (tecs.success) this.tecnicos = tecs.data || [];
        if (ests.success) this.estados = ests.data || [];
      } catch (error) {
        console.error('Error cargando catálogos:', error);
      }
    },

    async cargarDatos() {
      this.cargando = true;
      try {
        const res = await api.obtenerRecepciones();
        if (res.success) {
          this.recepciones = res.data || [];
          await this.aplicarFiltros();
        } else {
          this.toast.error('Error al cargar datos');
        }
      } catch (error) {
        console.error('Error cargando datos:', error);
        this.toast.error('Error de conexión');
      } finally {
        this.cargando = false;
      }
    },

    async aplicarFiltros() {
      let result = [...this.recepciones];

      if (this.filtros.idEstado !== 'todos') {
        const estadoObj = this.estados.find(e => e.idEstadoRecepcion === this.filtros.idEstado);
        if (estadoObj) {
          result = result.filter(r => r.nombreEstado === estadoObj.nombre);
        }
      }

      if (this.filtros.idTecnico !== 'todos') {
        const tecObj = this.tecnicos.find(t => t.idTecnico === this.filtros.idTecnico);
        if (tecObj) {
          const nombreCompleto = `${tecObj.nombre} ${tecObj.apellido || ''}`.trim();
          result = result.filter(r => r.nombreTecnico === nombreCompleto);
        }
      }

      if (this.filtros.fechaDesde) {
        result = result.filter(r => {
          const fechaRef = r.fechaPago || r.fechaEntrega || r.fechaIngreso;
          const match = String(fechaRef || '').match(/^(\d{4}-\d{2}-\d{2})/);
          const fecha = match ? match[1] : '';
          return fecha >= this.filtros.fechaDesde;
        });
      }

      if (this.filtros.fechaHasta) {
        result = result.filter(r => {
          const fechaRef = r.fechaPago || r.fechaEntrega || r.fechaIngreso;
          const match = String(fechaRef || '').match(/^(\d{4}-\d{2}-\d{2})/);
          const fecha = match ? match[1] : '';
          return fecha <= this.filtros.fechaHasta;
        });
      }

      this.recepcionesFiltradas = result;
      this.paginaActual = 1;
      
      await this.cargarPagosRecepciones();
      this.estadisticas = this.calcularEstadisticasFinales();
    },

    async cargarPagosRecepciones() {
      try {
        const resPagos = await obtenerPagosSalidaEquipo();
        if (resPagos.success) {
          this.pagosGlobales = resPagos.data || [];
          await this.procesarMontosCobrados();
        }
      } catch (e) { 
        console.error('Error obteniendo pagos de salida', e); 
      }
    },

    /**
     * ⭐ LÓGICA DE COBRADO (igual que PagoServicio.vue)
     * 
     * - Se suman TODOS los pagos con monto > 0
     * - NO se filtra por método (CACHEAS ya es un pago real que entró al local)
     * - El Cashea (pendiente) = Total Neto - Cobrado
     */
    async procesarMontosCobrados() {
      const pagos = this.pagosGlobales;

      this.recepcionesFiltradas = this.recepcionesFiltradas.map(r => {
        const rId = r.idRecepcionEquipo || r.id_recepcion_equipo;
        const rNum = String(r.numeroOrden || r.numero_orden || '').trim();

        // 1. Buscar TODOS los pagos de esta recepción
        const pagosRecepcion = pagos.filter(p => {
          const pId = p.idRecepcionEquipo || p.id_recepcion_equipo || p.idRecepcion || p.id_recepcion;
          const pNum = String(p.numeroOrden || p.numero_orden || '').trim();
          const recibo = String(p.numeroRecibo || p.numero_recibo || '').trim();

          if (pId && rId && Number(pId) === Number(rId)) return true;
          if (pNum && rNum && pNum === rNum) return true;
          if (recibo && rNum && new RegExp(`\\b${rNum}\\b`).test(recibo)) return true;

          return false;
        });

        // 2. Sumar TODOS los pagos con monto > 0
        const montoCobradoUsd = pagosRecepcion.reduce((sum, p) => {
          const monto = Number(p.montoUsd || p.monto_usd) || 0;
          if (monto > 0) return sum + monto;
          return sum;
        }, 0);

        // 3. Calcular Cashea (lo que falta por cobrar)
        const totalOrden = Number(r.precioTotalUsd || 0) || 0;
        const descuento  = Number(r.descuento || 0) || 0;
        const totalNeto  = totalOrden - descuento;
        const cashea     = Math.max(0, totalNeto - montoCobradoUsd);

        return {
          ...r,
          montoCobradoUsd,
          montoPendienteUsd: cashea,
          totalNetoUsd: totalNeto
        };
      });
    },

    /**
     * ⭐ Calcula todas las estadísticas incluyendo Cobrado y Cashea
     */
    calcularEstadisticasFinales() {
      const base = calcularEstadisticasRecepcion(this.recepcionesFiltradas);
      
      const totalCobrado = this.recepcionesFiltradas.reduce(
        (sum, r) => sum + (Number(r.montoCobradoUsd) || 0), 0
      );
      
      const totalCashea = this.recepcionesFiltradas.reduce(
        (sum, r) => sum + (Number(r.montoPendienteUsd) || 0), 0
      );

      return {
        ...base,
        totalCobrado,
        totalCashea
      };
    },

    limpiarFiltros() {
      const d = new Date();
      const hoy = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      this.filtros = {
        idEstado: 'todos',
        idTecnico: 'todos',
        fechaDesde: hoy,
        fechaHasta: ''
      };
      this.paginaActual = 1;
      this.aplicarFiltros();
      this.toast.info('Filtros limpiados');
    },

    async exportarExcel() {
      const res = exportarRecepcionExcel(this.recepcionesFiltradas);
      if (res.success) this.toast.success('Excel generado correctamente');
      else this.toast.error('Error al generar Excel');
    },

    async imprimirReporte() {
      await imprimirReporteRecepcion(this.recepcionesFiltradas, this.obtenerTituloReporte());
    },

    obtenerTituloReporte() {
      let titulo = 'REPORTE DE REPARACIÓN DE EQUIPOS';
      const partes = [];
      
      if (this.filtros.idEstado !== 'todos') {
        const est = this.estados.find(e => e.idEstadoRecepcion === this.filtros.idEstado);
        if (est) partes.push(est.nombre.toUpperCase());
      }
      
      if (this.filtros.idTecnico !== 'todos') {
        const tec = this.tecnicos.find(t => t.idTecnico === this.filtros.idTecnico);
        if (tec) partes.push(`TÉCNICO: ${tec.nombre.toUpperCase()}`);
      }
      
      if (this.filtros.fechaDesde || this.filtros.fechaHasta) {
        partes.push(`${this.filtros.fechaDesde || 'INICIO'} al ${this.filtros.fechaHasta || 'HOY'}`);
      }
      
      if (partes.length > 0) titulo += ` - ${partes.join(' - ')}`;
      return titulo;
    },

    volver() {
      this.$router.push('/dashboard');
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Extra small breakpoint para móviles muy pequeños */
@media (max-width: 400px) {
  .xs\:inline {
    display: inline !important;
  }
  .xs\:text-left {
    text-align: left !important;
  }
  .xs\:flex-row {
    flex-direction: row !important;
  }
  .xs\:hidden {
    display: none !important;
  }
}
</style>